import { v4 as uuidv4 } from 'uuid';
import { AccessPermissionsTextEnum } from '../CreateMemorialQuiltStepTwo/const';
import { isVac } from 'utilities/is-vac';
import { Language } from 'providers/translates/enums';
import { interpolateMarkdown } from 'components/MarkdownRenderer/helpers';

export const createInvite = (email?: string, access?: AccessPermissionsTextEnum) => ({
  id: uuidv4(),
  email: email || '',
  access: access || AccessPermissionsTextEnum.EDIT_IMAGES,
});

export const getEverythingAfterFirst = (message: string) => {
  const parts = message.split("\n\n");
  return parts.slice(1).join("\n\n"); 
}

export const generateMessage = (
  selectedLang: string, 
  ownerName: string, 
  pageName?: string,
  strapiText?: string
) => {
  if (strapiText) {
    return interpolateMarkdown(strapiText, {ownerName, pageName: pageName ?? ''})
  }

  if (!isVac()) {
    return selectedLang === Language.FRENCH ? `Hello, \n\n${ownerName || ''} has invited you to add to a memorial quilt square for ${pageName ?? ''}.\n\n` : `Hello, \n\n${ownerName || ''} has invited you to add to a memorial quilt square for ${pageName ?? ''}.\n\n`;
  } 

  return selectedLang === Language.FRENCH ? `Vous êtes invité·e à contribuer à la réalisation d’un carreau de courtepointe sur le site « Saluons leur service » pour rendre hommage à ${pageName ?? ''}.\n\n` : `You've been invited to contribute to a Saluting Service quilt square for ${pageName ?? ''}.\n\n`;
};
